import useNavigate from './useNavigate';

export const navigationHooks = {
  useNavigate,
};
export type { NavigateProps, RoutePath, Routes } from './useNavigate';
